import { JobItem } from '@kanda-libs/ks-frontend-services';

export const getEnquiryTotalFromItems = (items: JobItem[]): number =>
  items.reduce((total: number, item: JobItem) => {
    const priceAmount = item.price.amount;
    const vatAmount = item.vat.amount;
    return total + priceAmount + vatAmount;
  }, 0);
